import i18n, { type BackendModule } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const localeLoaders: Record<string, () => Promise<{ default: object }>> = {
  en: () => import('./locales/en/translation.json'),
  ru: () => import('./locales/ru/translation.json'),
  tr: () => import('./locales/tr/translation.json'),
};

const localeBackend: BackendModule = {
  type: 'backend',
  init: () => undefined,
  read: (language, _namespace, callback) => {
    const loader = localeLoaders[language] ?? localeLoaders.ru;
    loader()
      .then(({ default: translations }) => callback(null, translations))
      .catch((error: Error) => callback(error, false));
  },
};

i18n
  .use(localeBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['ru', 'en', 'tr'],
    load: 'languageOnly',
    fallbackLng: 'ru',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
